import {IAssignedRoleDto, OrpyxRoleType} from "admins-dashboard/http-clients/index";

export const adminAvailableRolesPipe = (roles: IAssignedRoleDto[] | undefined): OrpyxRoleType[] => {
    if (roles) {
        return roles.filter(role => role.role && role.role.role).map(role => role.role!.role!);
    }
    return [];
};
export default adminAvailableRolesPipe;
